import React from 'react'
import { Field, reduxForm  } from 'redux-form'
import RenderFields from './RenderFields'
import RenderTextArea from './RenderTextArea'

import {
  email,
  aol,
  emailRequired,
  messageRequired,
  firstName,
  lastName

} from './Validate'

let ContactForm = props => {
  const { handleSubmit, pristine,  submitting } = props
  return (
    <div className="form-wrap">
        <form onSubmit={handleSubmit}>
          <Field
            name="firstName"
            type="firstName"
            component={RenderFields}
            label="First Name"
            validate={firstName}
          />

          <Field
            name="lastName"
            type="lastName"
            component={RenderFields}
            label="Last Name"
            validate={lastName}
          />
          <Field
            name="email"
            type="email"
            component={RenderFields}
            label="Please add your Email"
            validate={[email , emailRequired]}
            warn={aol}
          />
          <div className="messagebox">
            <Field 
              name="message" 
              label="Type your message" 
              component={RenderTextArea} 
              type="textarea" 
              validate={messageRequired}
              />
          </div>
          
          <button type="submit" disabled={pristine || submitting} >Submit</button>
        </form>
    </div>
  )
}

ContactForm = reduxForm({
  // a unique name for the form
  form: 'contact'
})(ContactForm)

export default ContactForm


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Contact/components/ContactForm.js